export enum DateType {
    days = 'daysInfo',
    hours = 'hoursInfo',
    weeks = 'weeksInfo'
}